import MenuItem from '../menu/menu-item';

/**
 * @deprecated use Menu.Item class instead: import { MenuItem } from 'main.popup'
 */
export default class PopupMenuItem extends MenuItem
{

}